const MIN_CHARS_SEARCH: number = 2;
const VALUE_UPDATE_DELAY_IN_MS: number = 500;

export { MIN_CHARS_SEARCH, VALUE_UPDATE_DELAY_IN_MS };
